import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ConfigProvider } from "antd";
import "./assets/style/main.scss";
import { Provider } from "react-redux";
import store from "../src/store";
// import "../src/utils/api"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ConfigProvider theme={{ cssVar: false, hashed: false }}>
      <App />
    </ConfigProvider>
  </Provider>
  // </React.StrictMode>
);
